import { HelpButton } from '@components/help/HelpButton'
import Page from '@components/Page/Page'
import Segment from '@components/segment/Segment'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import Feature from '@components/Feature'
import { Space } from 'antd'

const SegmentsPage = () => {
  return (
    <Page
      pageTitle={{
        title: 'Segments',
        level: 4,
        // The page itself is always reachable — existing segments stay readable
        // wherever the criteria endpoints are not deployed yet. Only creating one
        // is gated, since that is what needs the bo-api CRUD.
        // Inline: a toolbar button cannot be framed, so a preview gets its tag.
        toolbar: (
          <Feature flag="customSegments" preview="inline">
            <Space>
              <HelpButton articleId="122" />
              <SBRM.Actions
                actions={[SBRMAction.Create]}
                entity={Entity.segment}
              />
            </Space>
          </Feature>
        ),
      }}
    >
      <Segment.CardList />
    </Page>
  )
}

export default SegmentsPage
